const levels = ['trace', 'debug', 'info', 'warn', 'error', 'fatal'];
const shouldLog = (configLevel, msgLevel) => {
    return levels.indexOf(msgLevel) >= levels.indexOf(configLevel);
};
const formatMessage = (name, level, obj, msg) => {
    const timestamp = new Date().toISOString();
    const prefix = `[${timestamp}] ${level.toUpperCase()} ${name}:`;
    if (typeof obj === 'string') {
        console.log(prefix, obj);
    }
    else if (msg) {
        console.log(prefix, msg, obj);
    }
    else {
        console.log(prefix, obj);
    }
};
export const createLogger = (name, options) => {
    const level = (options?.level || 'info');
    const createLogMethod = (msgLevel) => {
        return (obj, msg) => {
            if (shouldLog(level, msgLevel)) {
                formatMessage(name, msgLevel, obj, msg);
            }
        };
    };
    const logger = {
        trace: createLogMethod('trace'),
        debug: createLogMethod('debug'),
        info: createLogMethod('info'),
        warn: createLogMethod('warn'),
        error: createLogMethod('error'),
        fatal: createLogMethod('fatal'),
        child: (bindings) => {
            const childName = bindings.name || name;
            return createLogger(`${name}:${childName}`, options);
        },
    };
    return logger;
};
export const logger = createLogger('app');
